import { getItems } from "../Api";

export interface SpecSheet {
  id: string;
  name: string;
  url: string;
  fileSize: number;
}

export async function getProductSpecSheets(productIds: string[]) {
  let queryString = productIds.map((p) => `productIds=${encodeURIComponent(p)}`).join("&");
  return getItems<SpecSheet>(`pricing/specsheet/products?${queryString}`);
}
